import React from 'react';
import AdminHeader from './AdminHeader';

const UserManagement = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <AdminHeader
            title="User Management"
            description="Manage user accounts and permissions"
          />
          
          <div className="bg-white rounded-lg shadow p-6">
            <p className="text-gray-600">User management interface coming soon...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserManagement;